import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../commons/shared.module';
import { JobListComponent } from './job-list.component';
import { JobComponent } from './job.component';
import {APIDialog} from '../../commons/dialogs/explorer.dialogs'

const AppRoutes: Routes = [
 
    { path: '', component:JobListComponent, pathMatch: 'full'}
];

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
      
        SharedModule,
        RouterModule.forChild(AppRoutes)
    ],

    declarations: [
        JobListComponent,JobComponent
    ],
    entryComponents:[APIDialog]
})

export class JobsModule {
   
   
}
